import React from 'react';
import { useMonthlyRotaForm } from '../context/MonthlyRotaContext';
import { FaCopy, FaCalendarAlt } from 'react-icons/fa';

const Step1MonthlyDetails = () => {
  const { formData, updateField } = useMonthlyRotaForm();

  return (
    <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-200">
      <div className="flex items-center gap-2.5 mb-5">
        <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white font-bold text-sm">1</div>
        <div>
          <h2 className="text-md font-bold text-gray-900">Rota Details</h2>
          <p className="text-[11px] text-gray-400">Set the basic information for this monthly rota.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Rota Name *</label>
          <input 
            type="text" 
            placeholder="e.g. May 2026 - Main Kitchen" 
            className="w-full text-xs p-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500"
            value={formData.rotaName}
            onChange={(e) => updateField('rotaName', e.target.value)}
          />
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Location *</label>
          <select 
            className="w-full text-xs p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
            value={formData.location}
            onChange={(e) => updateField('location', e.target.value)}
          >
            <option>Sunset Restaurant</option>
          </select>
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Month & Year *</label>
          <div className="relative">
            <input 
              type="month" 
              className="w-full text-xs p-2 border border-gray-300 rounded-md focus:outline-none"
              value={formData.monthYear}
              onChange={(e) => updateField('monthYear', e.target.value)}
            />
          </div>
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Rota Type</label>
          <select 
            className="w-full text-xs p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
            value={formData.rotaType}
            onChange={(e) => updateField('rotaType', e.target.value)}
          >
            <option>Monthly</option>
            <option>Weekly</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Working Pattern</label>
          <select 
            className="w-full text-xs p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
            value={formData.workingPattern}
            onChange={(e) => updateField('workingPattern', e.target.value)}
          >
            <option value="">Select pattern</option>
          </select>
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Copy Previous From</label>
          <div className="flex gap-2">
            <select 
              className="w-full text-xs p-2 border border-gray-300 rounded-md bg-white focus:outline-none"
              value={formData.copyPreviousFrom}
              onChange={(e) => updateField('copyPreviousFrom', e.target.value)}
            >
              <option value="None">None</option>
              <option value="April 2026">April 2026</option>
            </select>
            <button type="button" className="flex items-center gap-1.5 px-3 py-2 bg-blue-50 border border-blue-200 text-blue-600 font-semibold text-xs rounded-md whitespace-nowrap hover:bg-blue-100 transition">
              <FaCopy /> Copy Last Month's Rota
            </button>
          </div>
        </div>
        <div>
          <label className="block text-[11px] font-semibold text-gray-600 mb-1">Notes (Optional)</label>
          <input 
            type="text"
            placeholder="e.g. holiday cover, special events, bank holiday changes" 
            className="w-full text-xs p-2 border border-gray-300 rounded-md focus:outline-none"
            value={formData.notes}
            onChange={(e) => updateField('notes', e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default Step1MonthlyDetails;
